import { twMerge } from 'tailwind-merge';
import { TooltipProvider } from '@monksflow/monks-ui';
import type { PageHeaderProps } from './PageHeader.types';

/**
 * Shared page header shell: a fixed 56px card carrying an identity group on
 * the left and an action group on the right.
 *
 * The five header variants in the design are compositions of the parts in this
 * folder rather than a closed variant enum, because the tool badge pairs with
 * either a title or a breadcrumb and the info button appends to any of them.
 *
 * The shell mounts its own TooltipProvider because several of those parts carry
 * tooltips, and Radix throws rather than degrading when one is missing. The app
 * mounts providers per-feature, so there is no ambient one to rely on: a host
 * that composes the parts without this shell mounts its own.
 */
export function PageHeader(props: PageHeaderProps) {
  return (
    <TooltipProvider>
      <header
        data-testid="page-header"
        className={twMerge(
          'flex h-[56px] w-full items-center justify-between gap-md rounded-lg bg-card text-foreground',
          props.focus ? 'px-xs' : 'pr-md pl-xl',
          props.className,
        )}
      >
        {props.children}
      </header>
    </TooltipProvider>
  );
}
